// 357: malá oslava po potvrzení úkolu (podle laboratoře, styl Asana): 22 konfet vyletí z tlačítka,
// otočí se a spadnou (0,9–1,25 s). Při omezeném pohybu (prefers-reduced-motion) nic nelétá.
const COLORS = ["#e0703f", "#2a8467", "#3fbf8f", "#f5c46b", "#7a5bb5", "#2f6f9f"];

export function celebrate(el) {
  if (!el || typeof document === "undefined") return;
  try { if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return; } catch { /* starší prohlížeč */ }
  const r = el.getBoundingClientRect();
  const cx = r.left + r.width / 2, cy = r.top + r.height / 2;
  for (let i = 0; i < 22; i++) {
    const p = document.createElement("i");
    p.className = `pp-cf${i % 3 === 0 ? " pp-cf--dot" : ""}`;
    p.setAttribute("aria-hidden", "true");
    Object.assign(p.style, { left: `${cx}px`, top: `${cy}px`, background: COLORS[i % COLORS.length] });
    document.body.appendChild(p);
    if (typeof p.animate !== "function") { p.remove(); continue; }
    const a = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.25, d = 46 + Math.random() * 70;
    const dx = Math.cos(a) * d, dy = Math.sin(a) * d, rot = (Math.random() - 0.5) * 540;
    p.animate([
      { transform: "translate(-50%,-50%) scale(.4)", opacity: 1 },
      { transform: `translate(calc(-50% + ${dx}px), calc(-50% + ${dy}px)) rotate(${rot}deg) scale(1)`, opacity: 1, offset: 0.5 },
      { transform: `translate(calc(-50% + ${dx * 1.2}px), calc(-50% + ${dy + 56}px)) rotate(${rot * 1.6}deg) scale(.8)`, opacity: 0 },
    ], { duration: 900 + Math.random() * 350, easing: "cubic-bezier(.15,.7,.35,1)", fill: "forwards" });
    setTimeout(() => p.remove(), 1400);
  }
}
